export default __webpack_public_path__ + "static/media/tempo-up.1ef3a495.svg";